import { render } from "./ResumenJustificadas.vue?vue&type=template&id=0936eb43&scoped=true"
import script from "./ResumenJustificadas.vue?vue&type=script&lang=js"
export * from "./ResumenJustificadas.vue?vue&type=script&lang=js"

import "./ResumenJustificadas.vue?vue&type=style&index=0&id=0936eb43&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0936eb43"]])

export default __exports__